<p-dialog *ngIf="widget"
          header="{{ (widget.id ? 'ADD_CUSTOM_WIDGET_DIALOG.MODIFY_HEADER' : 'ADD_CUSTOM_WIDGET_DIALOG.NEW_HEADER') | translate }}"
          [(visible)]="display"
          [modal]="true"
          [draggable]="false" >
  <form [formGroup]="widgetForm" (submit)="save()">
    <div class="ui-g service-edit-dialog">
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-4">
            <label>{{ 'ADD_CUSTOM_WIDGET_DIALOG.TITLE_LABEL' | translate }}</label>
          </div>
          <div class="ui-g-8">
            <gs-extended-input [control]="widgetForm.get('title')">
              <input pInputText
                     maxlength="255"
                     formControlName="title"/>
            </gs-extended-input>
          </div>
          <div class="ui-g-4">
            <label>{{ 'ADD_CUSTOM_WIDGET_DIALOG.SIZE_LABEL' | translate }}</label>
          </div>
          <div class="ui-g-8">
            <gs-extended-input
              [control]="widgetForm.get('size')">
              <p-dropdown [options]="sizeOptions"
                          placeholder="{{ 'ADD_CUSTOM_WIDGET_DIALOG.SIZE_PLACEHOLDER' | translate }}"
                          formControlName="size">
              </p-dropdown>
            </gs-extended-input>
          </div>
          <div class="ui-g-4">
            <label>{{ 'ADD_CUSTOM_WIDGET_DIALOG.ROLE_LABEL' | translate }}</label>
          </div>
          <div class="ui-g-8">
            <gs-extended-input
                               [control]="widgetForm.get('roles')">
              <p-multiSelect [options]="userRolesOptions"
                          formControlName="roles">
              </p-multiSelect>
            </gs-extended-input>
          </div>
          <div class="ui-g-4">
              <label>{{ 'ADD_CUSTOM_WIDGET_DIALOG.RAW_INPUT' | translate }}</label>
          </div>
          <div class="ui-g-8">
            <p-checkbox (onChange)="onRawInputChange()"></p-checkbox>
          </div>
          <div class="ui-g-4">
            <label>{{ 'ADD_CUSTOM_WIDGET_DIALOG.CONTENT_LABEL' | translate }}</label>
          </div>
          <div class="ui-g-8" *ngIf="rawInput">
            <gs-extended-input [control]="widgetForm.get('content')">
              <textarea style="height: 320px" class="m-b-15" formControlName="content"></textarea>
            </gs-extended-input>
          </div>
          <div class="ui-g-8" *ngIf="!rawInput">
            <gs-extended-input [control]="widgetForm.get('content')">
              <p-editor formControlName="content" [style]="{'height':'320px'}" styleClass="m-b-15"></p-editor>
            </gs-extended-input>
          </div>
          <div class="ui-g-4"></div>
          <div class="ui-g-8 padding-top-20 text-right">
            <button pButton label="{{ (widget.id ? 'ADD_CUSTOM_WIDGET_DIALOG.UPDATE_BTN' : 'ADD_CUSTOM_WIDGET_DIALOG.ADD_BTN') | translate }}"
                    class="ui-button-success">
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
